export default __webpack_public_path__ + "static/media/upi.a644e421.png";